import script from "./BillingApplePriceComparison16218.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingApplePriceComparison16218.vue?vue&type=script&setup=true&lang=ts"

import "./BillingApplePriceComparison16218.vue?vue&type=style&index=0&id=6ff31284&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff31284"]])

export default __exports__